<template>
  <div class="base-div" :class="color">
    <NewToolbar
      @sidebar="updateToggleSidebar"
      @filter="updateToggleFilter"
      v-if="$vuetify.breakpoint.mdAndDown"
      :rule-button="
        Boolean(
          $route.name === 'timelineHome' ||
            ($route.name === 'roundTableItems' && debate?.showDebate) ||
            ($route.name === 'communityMembersHome' && community.id) ||
            ($route.name === 'communityHome' && community.id)
        )
      "
      :show-sidebar-filter="sidebarFilterVisible"
    />
    <NewSidebar
      :toggle="toggleSidebar"
      :is-notification="isNotification"
      :is-message-notification="isMessageNotification"
    />
    <SidebarFilter
      v-if="
        $route.name === 'timelineHome' ||
        ($route.name === 'roundTableItems' && debate?.showDebate) ||
        ($route.name === 'communityMembersHome' && community.id) ||
        ($route.name === 'communityHome' && community.id)
      "
      :debate="debate"
      :community="community"
      @leave="$emit('leave', community.id)"
      @openModalUser="$emit('openModalUser')"
      @edit="$emit('edit')"
      @delete="$emit('delete', community.id)"
      @sidebar-filter-visibility="updateSidebarFilterVisibility"
      :disabled="disabled"
      :current-loading-loungeId="currentLoadingLoungeId"
      :toggle="toggleFilter"
      :show-filter="$route.name === 'timelineHome'"
      :loading-filter="loadingFilter"
    />
    <v-main :class="color">
      <TheAlert
        v-model="alertNotification"
        @close="updateAlertNotificationStatus"
      />
      <v-container app :class="padding" fluid>
        <slot />
      </v-container>
    </v-main>
    <LoadingModal />
  </div>
</template>
<script lang="ts">
import TheAlert from "../components/TheAlert.vue";
import { Prop } from "vue-property-decorator";
import Component, { mixins } from "vue-class-component";
import { State, Action } from "vuex-class";
import { TokenService } from "@/api/storage";
import { ActionMixin } from "../mixins/ActionMixin";
import { getLoginRouteFromRole } from "@/mixins/LogoutMixin";
import LoadingModal from "../components/LoadingModal.vue";
import _ from "lodash";
import { api } from "@/api";
@Component({
  components: {
    TheAlert,
    LoadingModal,
  },
})
export default class NewMain extends mixins(ActionMixin) {
  @Prop({ default: "" }) title: any;
  @Prop({ default: "white" }) color: string;
  @Prop({ default: false }) routeFooter: boolean;
  @Prop({ default: "pa-4 px-md-0" }) padding: string;
  @Prop({ default: false }) button: boolean;
  @Prop({ default: "notification" }) actionButton: string;
  @Prop({ default: false }) isProfile: boolean;
  @Prop({ default: false }) loadingFilter: boolean;
  @Prop(Object) debate: any;
  @Prop(Object) community: any;
  @Prop(Number) currentLoadingLoungeId: number;
  @Prop(Boolean) disabled: boolean;
  @Prop(Object) detail: any;
  isNotification = false;
  isMessageNotification = false;
  isNewCommunity = false;
  toggleSidebar: any = null;
  toggleFilter: any = null;
  sidebarFilterVisible = false;
  isPageVisible = true;
  debounce = _.debounce(() => {
    if (this.isPageVisible) {
      this.fetchNotification();
    }
  }, 10000);
  debounceTransmission = _.debounce(() => {
    if (this.isPageVisible) {
      this.fetchIsTransmission();
    }
  }, 600000);
  debounceCommunity = _.debounce(() => {
    if (this.isPageVisible) {
      this.fetchNotificationCommunity();
    }
  }, 600000);
  debounceOnline = _.debounce(() => {
    if (this.isPageVisible) {
      this.fetchIsOnline();
    }
  }, 60000);
  @Action("profile/requestMe") requestMe: any;
  @Action("notification/requestIsNotification") requestIsNotification: any;
  @Action("notification/requestIsMessageNotification")
  requestIsMessageNotification: any;
  @Action("timeline/initializeAxios") initializeAxios: any;
  @State("alertNotification") alertNotification: any;
  @Action("community/requestIsNewCommunity") requestIsNewCommunity: any;
  @Action("community/requestRemoveNotificationCommunity")
  requestRemoveNotificationCommunity: any;
  @Action("transmission/requestCurrentTransmission")
  requestCurrentTransmission: any;
  @Action("transmission/requestNextTransmissionList")
  requestNextTransmissionList: any;
  @Action("onboarding/requestLogout") requestLogout: any;
  @Action("updateRouteAfterLogin") updateRouteAfterLogin: any;
  @Action("timeline/requestBannerImages") requestBannerImages: any;
  @Action("community/requestCommunityPending") requestCommunityPending: any;
  @Action("updateAlertNotificationStatus") updateAlertNotificationStatus: any;
  @Action("profile/requestIsOnline") requestIsOnline: any;
  get classContent(): string {
    return `${this.color} ${this.padding}`;
  }
  created(): void {
    this.$root.$i18n.locale = TokenService.getLanguage() || "pt";
    this.$root.$i18n.fallbackLocale = TokenService.getLanguage() || "pt";
    this.setupPageVisibilityListener();
    if (!api) {
      this.initializeAxios().then(() => {
        this.fetchData();
      });
    } else {
      this.fetchData();
    }
  }
  fetchData(): void {
    this.fetchMe();
    this.fetchNotification();
    this.fetchNotificationCommunity();
    this.fetchIsTransmission();
    this.fetchBannerImages();
    this.fetchIsOnline();
  }
  async fetchMe(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestMe().then((data: any) => {
        if (
          !data.permissions.includes("ACCESS_WEB_ADMIN") &&
          (data.role === "FOUR_NETWORK" || data.role === "MARKETING")
        ) {
          this.updateRouteAfterLogin({ name: "", params: {} });
          this.requestLogout();
          this.$router.push({ name: getLoginRouteFromRole(data.role) });
        } else {
          this.$vuetify.theme.dark = data.userTheme === "DARK";
          const rules = data.permissions.reduce(
            (string: string, rule: string, index: number) => {
              if (index === data.permissions.length - 1)
                return (string += rule);
              string += rule + ", ";
              return string;
            },
            ""
          );
          TokenService.saveRule(rules);
        }
      });
    });
  }
  fetchNotification(): void {
    this.fetchIsNotification();
    this.fetchIsMessageNotification();
  }
  fetchNotificationCommunity(): void {
    this.fetchIsIsNewCommunity();
    this.fetchCommunityNotification();
  }
  async fetchIsNotification(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestIsNotification().then((data: boolean) => {
        this.isNotification = data;
      });
    });
  }
  async fetchIsMessageNotification(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestIsMessageNotification().then((data: boolean) => {
        this.isMessageNotification = data;
        this.debounce();
      });
    });
  }
  async fetchIsIsNewCommunity(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestIsNewCommunity().then((data: boolean) => {
        this.isNewCommunity = data;
        if (data)
          setTimeout(() => {
            this.removeNotification();
          }, 5000);
      });
    });
  }
  removeNotification(): void {
    this.isNewCommunity = false;
  }
  async fetchCommunityNotification(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestCommunityPending().then(() => {
        this.debounceCommunity();
      });
    });
  }
  async fetchIsTransmission(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestNextTransmissionList().then(() => {
        this.fetchCurrentTransmission();
      });
    });
  }
  async fetchCurrentTransmission(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestCurrentTransmission().then(() => {
        this.debounceTransmission();
      });
    });
  }
  async fetchBannerImages(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestBannerImages();
    });
  }
  async fetchIsOnline(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestIsOnline().then(() => {
        this.debounceOnline();
      });
    });
  }
  updateToggleSidebar(): void {
    this.toggleSidebar = !this.toggleSidebar;
  }
  updateToggleFilter(): void {
    this.toggleFilter = !this.toggleFilter;
  }
  updateSidebarFilterVisibility(isVisible: boolean): void {
    this.sidebarFilterVisible = isVisible;
  }
  setupPageVisibilityListener(): void {
    // Detecta quando a aba fica visível/invisível
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    // Detecta quando a janela perde/ganha foco (complementar ao visibilitychange)
    window.addEventListener("focus", this.handleWindowFocus);
    window.addEventListener("blur", this.handleWindowBlur);
  }
  handleVisibilityChange(): void {
    this.isPageVisible = !document.hidden;

    // Se a aba voltou a ficar visível, executa as chamadas imediatamente
    if (this.isPageVisible) {
      this.fetchNotification();
      this.fetchNotificationCommunity();
      this.fetchIsTransmission();
      this.fetchIsOnline();
    }
  }
  handleWindowFocus(): void {
    this.isPageVisible = true;
    this.fetchNotification();
    this.fetchNotificationCommunity();
    this.fetchIsTransmission();
    this.fetchIsOnline();
  }
  handleWindowBlur(): void {
    this.isPageVisible = false;
  }
  beforeDestroy(): void {
    this.debounce.cancel();
    this.debounceTransmission.cancel();
    this.debounceCommunity.cancel();
    this.debounceOnline.cancel();
    // Remove os listeners para evitar memory leaks
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    window.removeEventListener("focus", this.handleWindowFocus);
    window.removeEventListener("blur", this.handleWindowBlur);
  }
}
</script>
<style lang="sass">
.container
  max-width: 100% !important
.max-content-width
  @media(max-width: 600px)
    width: 100%
  @media(min-width: 600px)
    max-width: 600px
    min-width: 600px
    margin: 0 auto !important
  @media(min-width: 700px)
    max-width: 700px
    min-width: 700px
    margin: 0 auto !important
.max-content-toolbar
  @media(max-width: 600px)
    width: 100%
  @media(min-width: 600px)
    width: 100%
    margin: 0 auto !important
  @media(min-width: 960px)
    max-width: 960px
    min-width: 960px
    margin: 0 auto !important
  @media(min-width: 1135px)
    max-width: 1135px
    min-width: 1135px
    margin: 0 auto !important
.max-content-settings
  @media(max-width: 1050px)
    width: 100%
  @media(min-width: 1050px)
    max-width: 1050px
    min-width: 1050px
    margin: 0 auto !important
.max-content-table
  @media(max-width: 835px)
    width: 100%
  @media(min-width: 835px)
    max-width: 835px
    min-width: 835px
    margin: 0 auto !important
</style>
